/* eslint-disable max-classes-per-file */

import { Http, Uri, Extension, Type } from 'main.core';

declare type AnalyticsOptions = {
	isEnabled: boolean,
};

declare type AnalyticsContext = {
	authType: string,
	authSubType: string,
	userId: number,
	sessionId: string,
	startPoint: string,
	portalName: string,
};

declare type AnalyticsConfig = {
	options: AnalyticsOptions,
	context: AnalyticsContext,
};

export class AnalyticsEventType
{
	static SESSION_START = 'session_begin';

	static SHOW_CREATE_PORTAL_ENTER_LOGIN_PAGE = 'web_select_mail_social';
	static SHOW_PORTALS_LIST_PAGE = 'web_show_portals_list';
	static SHOW_CREATE_PORTAL_CONFIRM_PAGE = 'web_portal_create_confirm';
	static SHOW_CREATE_PORTAL_EXIST_TOO_MUCH_PAGE = 'web_portal_create_exist_too_much';
	static SHOW_CREATE_PORTAL_STARTED_PAGE = 'web_portal_create_progress';
	static SHOW_CREATE_PORTAL_ERROR_PAGE = 'web_portal_create_error';
	static SHOW_CREATE_PORTAL_FINISHED_PAGE = 'web_portal_create_welcome';
	static SHOW_AUTH_ENTER_LOGIN_PAGE = 'web_validate_mail_phone';
	static SHOW_AUTH_CHOOSE_EXISTED_PAGE = 'web_auth_choose_existed';
	static SHOW_ENTER_PASSWORD_PAGE = 'web_enter_password';
	static SHOW_CREATE_PASSWORD_PAGE = 'web_first_password';
	static SHOW_FORGOT_PASSWORD_PAGE = 'web_forget_password_validate_mail_phone';
	static SHOW_ENTER_SMS_CODE_PAGE = 'web_enter_code_from_sms';
	static SHOW_ENTER_EMAIL_CODE_PAGE = 'web_enter_code_from_email';
	static SHOW_SET_NEW_PASSWORD_PAGE = 'web_set_new_password';
	static SHOW_QR_CODE_AUTH_PAGE = 'web_scan_auth_qr';
	static SHOW_REDIRECT_CHOOSE_PORTAL_PAGE = 'web_redirect_choose_portal';
	static SHOW_ERROR_PAGE = 'web_auth_error';
	static SHOW_INVITE_CONFIRM_PAGE = 'web_invite_agree';
	static SHOW_INVITE_WAIT_ADMIN_CONFIRMATION_PAGE = 'web_invite_wait_for_admin';
	static SHOW_NOT_YOUR_PORTAL_PAGE = 'web_auth_wrong_user';
	static SHOW_AUTH_FIRED_PAGE = 'web_auth_fired';
	static SHOW_INVITE_ENTER_USER_INFO_PAGE = 'web_invite_user_info';
	static SHOW_INVITE_ENTER_USER_PASSWORD_CREATING_PAGE = 'web_invite_user_password_creating';
	static SHOW_INVITE_ENTER_LOGIN_PAGE = 'web_invite_select_mail_social';
	static SHOW_INVITE_CONFIRM_EMAIL_PAGE = 'web_invite_need_confirm_mail';
	static SHOW_INVITE_ENTER_PASSWORD_PAGE = 'web_invite_password_entering';

	static SHOW_AUTH_SOCSERV_POPUP = 'web_social_account_show';
	static SHOW_AUTH_SOCSERV_NOTIFICATION_SHOWN = 'web_social_account_notification';

	static SHOW_AUTH_LOGIN_NOT_CONFIRMED_EMAIL_PAGE = 'web_login_not_confirmed_email';
	static SHOW_AUTH_LOGIN_NOT_CONFIRMED_EMAIL_ERROR = 'web_login_not_confirmed_email_error';
	static SHOW_AUTH_LOGIN_NOT_CONFIRMED_EMAIL_SUCCESS = 'web_login_not_confirmed_email_success';

	// old push
	static MOBILE_POPUP_SHOW = 'web_mobile_popup_show';
	static MOBILE_POPUP_CLOSE = 'web_mobile_popup_close';
	static MOBILE_POPUP_GO_APP = 'web_mobile_popup_go_app';

	// new push
	static PUSH_MOBAPP_SHOW = 'push_mobapp_show';
	static PUSH_MOBAPP_CLICK_START = 'push_mobapp_click_start';
	static PUSH_MOBAPP_CLICK_STAY_BROWSER = 'push_mobapp_click_stay_browser';
	static PUSH_MOBAPP_SHOW_ALLOW_PASTE = 'push_mobapp_show_allow_paste';
	static PUSH_MOBAPP_CLICK_ALLOW_PASTE = 'push_mobapp_click_allow_paste';

	static SEND_EMAIL_RESTORE_PASSWORD = 'mail_send_restore_password';

	static QR_CODE_AUTH_SUCCESS = 'qr_mobile2web_auth_complete';

	static ERROR_EMAIL_NOT_FOUND = 'web_auth_email_not_found';
	static ERROR_PHONE_NOT_FOUND = 'web_auth_phone_not_found';
	static ERROR_WRONG_PASSWORD = 'web_auth_wrong_password';
	static ERROR_WRONG_PASSWORD_OR_CAPTCHA = 'web_auth_wrong_password_or_captcha';
	static ERROR_USE_SOCSERV_EMAIL = 'web_auth_use_socserv_email';

	static PORTAL_CREATE_FORM_ACTIVITY = 'web_select_mail_social_first_activity';
	static PORTAL_CREATE_FORM_ERROR = 'web_select_mail_social_error';

	static REDIRECT_TO_PORTAL = 'web_portal_go_inside';

	static FLOW_TOKEN_SHOW_POPUP = 'flow_token_show_popup';

	// Used to detect adaptive captcha solving attempts
	static CAPTCHA_SHOWED = 'web_captcha_showed';
	// It is shown on multiple failed authorization attempts
	static CAPTCHA_SHOWED_OLD_BITRIX = 'web_captcha_showed_bx';

	static WEST_SOCSERV_AUTH_SHOW = 'west_socserv_auth_show';
	static WEST_SOCSERV_AUTH_RESEND_EMAIL = 'west_socserv_auth_resend_email';

	// Used for detecting how often users click on mobile app icons below QR code in new design
	static CLICK_ON_IOS_MOBILE_APP_ICON = 'web_click_on_ios_mobile_app_icon';
	static CLICK_ON_ANDROID_MOBILE_APP_ICON = 'web_click_on_android_mobile_app_icon';
	static CLICK_ENTER_BUTTON = 'web_enter_button_click';
	static CLICK_CREATE_B24_BUTTON = 'web_create_b24_button_click';
	static CLICK_EXIT_BUTTON = 'web_exit_button_click';

	static AUTHORIZATION_LOGIN_ENTERED = 'web_authorization_login_entered';

	static INSTALL_MOBILE_APP_SHOW_ENTRY = 'install_mobile_app_show_entry';
	static INSTALL_MOBILE_APP_SHOW_CREATE_PASSWORD = 'install_mobile_app_show_create_password';
	static INSTALL_MOBILE_APP_SHOW_CONFIRM_EMAIL = 'install_mobile_app_show_confirm_email';
	static INSTALL_MOBILE_APP_SHOW_SUCCESS_INSTALL = 'install_mobile_app_show_success_install';
	static INSTALL_MOBILE_APP_SHOW_RESEND_CONFIRM_EMAIL = 'install_mobile_app_show_resend_confirm_email';
	static INSTALL_MOBILE_APP_SKIP = 'install_mobile_app_skip';
	static INSTALL_MOBILE_APP_CONTINUE = 'install_mobile_app_continue';
	static INSTALL_MOBILE_APP_AUTH_ERROR = 'install_mobile_app_auth_error';

	static USER_REGISTER_LOGIN_ENTERED = 'web_register_login_entered';

	static PASSPORT_PAGE_SHOW = ' web_passport_page_show';
	static PASSPORT_EXIT_CLICK = 'web_passport_exit_click';
	static PASSPORT_CREATE_B24_CLICK = 'web_passport_create_b24_click';

	static PASSWORD_RESTORE_MAIL_SENT_PAGE = 'web_password_restore_email_sent_page';
}

export class Analytics
{
	constructor(config: AnalyticsConfig)
	{
		this.debugEnabled = (this.#getLocalSetting('EnableAnalyticsDebug') === 'y');

		this.setOptions(config.options);
		this.setContext(config.context);
		this.registerSessionStartEvent();
	}

	registerSessionStartEvent(): void
	{
		const existedSessionId = this.#getLocalSetting('AnalyticsSessionId');
		if (existedSessionId !== this.context.sessionId)
		{
			const alreadyVisited = this.#getLocalSetting('B24NET_ALREADY_VISITED');
			this.registerEvent(
				AnalyticsEventType.SESSION_START,
				{ has_previous_logins: alreadyVisited ? 1 : 0 },
			);

			if (!alreadyVisited)
			{
				this.#setLocalSetting('B24NET_ALREADY_VISITED', '1');
			}

			this.#setLocalSetting('AnalyticsSessionId', this.context.sessionId);
		}
	}

	registerEvent(eventName: string, eventArguments: Object = null): Promise
	{
		if (!this.#getOptionValue('isEnabled', true))
		{
			return Promise.resolve();
		}

		const data = this.#buildActionData(eventName, eventArguments);

		if (this.debugEnabled)
		{
			/* eslint-disable no-console */
			console.group();
			console.info('New analytics event:');
			console.table(data);
			console.groupEnd();
			/* eslint-enable */
		}

		const url = new Uri('/bitrix/services/main/ajax.php');
		url.setQueryParams({
			analyticsLabel: data,
			action: 'b24network.analytics.addEvent',
			sessid: BX.bitrix_sessid(),
		});

		if (!navigator.sendBeacon(url.toString()))
		{
			return BX.ajax.runAction(
				'b24network.analytics.addEvent',
				{
					analyticsLabel: data,
				},
			);
		}

		return Promise.resolve();
	}

	setOptions(options: AnalyticsOptions): void
	{
		this.options = {
			...options,
		};
	}

	getContext(): AnalyticsContext
	{
		return this.context;
	}

	setContext(context: AnalyticsContext): void
	{
		this.context = {
			...context,
		};
	}

	enableDebug(): void
	{
		this.debugEnabled = true;
		this.#setLocalSetting('EnableAnalyticsDebug', 'y');
	}

	#buildActionData(eventName: string, eventArguments: Object = null): Object
	{
		eventArguments = eventArguments || {};
		const userId = parseInt(this.#getContextValue('userId', 0), 10);
		let actionData = {
			session_id: this.#getContextValue('sessionId'),
			event_start_point: this.#getContextValue('startPoint'),
			event_auth_present: this.#getContextValue('userAuthorized') ? 1 : 0,
			event_auth_type: this.#getContextValue('authType'),
			event_auth_sub_type: this.#getContextValue('authSubType'),
			region_host: this.#getContextValue('regionHost'),
			region_user: this.#getContextValue('regionUser'),
			region_ip: this.#getContextValue('regionIp'),
			ev_category: eventName,
		};

		const abTests = this.#getContextValue('ab');
		if (Type.isPlainObject(abTests))
		{
			actionData = {
				...actionData,
				...abTests,
			};
		}

		const portalName = this.#getContextValue('portalName');
		if (portalName !== '')
		{
			actionData.portal_name = portalName;
		}

		if (userId > 0)
		{
			actionData.network_user_id = String(userId);
		}

		return {
			...actionData,
			...eventArguments,
		};
	}

	#getContextValue(fieldName: string, defaultValue = ''): any
	{
		return this.context.hasOwnProperty(fieldName) ? this.context[fieldName] : defaultValue;
	}

	#getOptionValue(fieldName: string, defaultValue = ''): any
	{
		return this.options.hasOwnProperty(fieldName) ? this.options[fieldName] : defaultValue;
	}

	#getLocalSetting(optionName: string): string
	{
		return Http.Cookie.get(optionName) ?? '';
	}

	#setLocalSetting(optionName: string, optionValue: string): void
	{
		Http.Cookie.set(optionName, optionValue, {
			expires: 60 * 60 * 24 * 7,
			path: '/',
		});
	}

	static instance = null;
	static create(context: AnalyticsContext): Analytics
	{
		Analytics.instance = new Analytics(context);

		return Analytics.instance;
	}

	static getInstance(): Analytics
	{
		if (Analytics.instance)
		{
			return Analytics.instance;
		}

		const settings = Extension.getSettings('b24network.component.useractions');
		Analytics.instance = new Analytics(settings.analyticsConfig);

		return Analytics.instance;
	}
}
